import React from 'react';

// 주소 검색 전용 선형 아이콘 — 외부 아이콘 폰트 없이 24px 격자의 인라인 SVG, 색은 currentColor
const PATHS = {
  search: (
    <>
      <circle cx="11" cy="11" r="7" />
      <path d="M20 20l-3.6-3.6" />
    </>
  ),
  close: <path d="M6 6l12 12M18 6L6 18" />,
  pin: (
    <>
      <path d="M12 21s-6.5-5.6-6.5-10.6A6.5 6.5 0 0 1 18.5 10.4C18.5 15.4 12 21 12 21z" />
      <circle cx="12" cy="10.4" r="2.3" />
    </>
  ),
  building: (
    <>
      <rect x="5" y="3.5" width="14" height="17" rx="1.5" />
      <path d="M9 8h2M13 8h2M9 12h2M13 12h2M10.5 20.5v-4h3v4" />
    </>
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.5V12l3 2" />
    </>
  ),
  down: <path d="M6 9l6 6 6-6" />,
};

function AddressIcon({ name, size = 20, className, style }) {
  const path = PATHS[name];
  if (!path) return null;
  return (
    <svg
      className={className}
      style={style}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {path}
    </svg>
  );
}

export default AddressIcon;
